import { render, staticRenderFns } from "./UnmappedAttributes.vue?vue&type=template&id=08969bd9&scoped=true&"
import script from "./UnmappedAttributes.vue?vue&type=script&lang=js&"
export * from "./UnmappedAttributes.vue?vue&type=script&lang=js&"
import style0 from "./UnmappedAttributes.vue?vue&type=style&index=0&id=08969bd9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08969bd9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
